import React from 'react';

import { highlighter } from '../../../helpers/uiFunctions/uiHelpers';

class BlogPreview extends React.Component {
    render() {
        const currentBlog = this.props.currentBlog;

        return(
            <div className="tab blog-2">
            {/* ARTICLE PREVIEW */}
                <h2>Article Preview</h2>
                {(currentBlog.text) && (
                    <div className="article-preview" id="preview" dangerouslySetInnerHTML={{ __html: highlighter(currentBlog.text) }} />
                )}
            </div>
        )
    }
}
export default BlogPreview;


// WEBPACK FOOTER //
// ./src/component_blog/components/BlogProfile/BlogPreview.js